<template>
  <div class="grid_body">
    <template v-if="list.length > 0">
      <div id="scroll-target-id" style="max-height: 600px; overflow-y: scroll;scrollbar-width: none;">
        <q-infinite-scroll @load="onLoad" :offset="100" :debounce="500" scroll-target="#scroll-target-id">
          <div v-for="(item, index) in list" :key="index">
            <div class="record-data grid_row" :key="index" :class='[ltTypecode == "PK10" && "fiveColumn"]'>
              <div class="grid_column" :class="[['LHC', 'LSC'].includes(ltTypecode) && 'LHC_column']">{{
                item.actualDrawingDate }}</div>
              <div class="grid_column" :class="[['LHC', 'LSC'].includes(ltTypecode) && 'LHC_column']">{{
                item.periodsNumber
              }}</div>
              <div class="grid_column" :class="[['LHC', 'LSC'].includes(ltTypecode) && 'LHC_column']">
                <div v-if="ltTypecode == 'K3'" :class="[ltTypecode == 'K3' && 'K3No' + lotteryNum[index][i]]"
                  class="openNum K3No " v-for="(items, i) in lotteryNum[index]" :key="i">
                </div>
                <div v-if="ltTypecode == '11X5'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items < 6) ? 'blueBall' : '', (f == 'dx' && items > 5) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items < 6">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 5">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == '3D'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items <= 4) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items <= 4">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 4">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == 'LHC' || ltTypecode == 'LSC'" class="openNum"
                  v-for="(items, i) in lotteryNum[index]" :class="[
                    (f == 'dx' && items < getSmallNum + 1) ? 'blueBall' : '',
                    (f == 'dx' && items > getSmallNum) ? 'redBall' : '',
                    (f == 'ds' && items % 2 == 0) ? 'redBall' : '',
                    (f == 'ds' && items % 2 != 0) ? 'blueBall' : '',
                    (f == 'num') ? 'lhc' + findNumbColor(items) : ''
                  ]" v-show="i + 1 != lotteryNum[index].length && 'true'" :key="i">
                  <template v-if="f == 'dx' && items < getSmallNum">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > getSmallNum - 1">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                  <div class="animals">
                    {{ findNumbAnimal(items, getAnimalList(item.periodsNumber, ltTypecode)) }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'LHC' || ltTypecode == 'LSC'" class="openNum noBackground ">
                  +
                </div>
                <div v-if="ltTypecode == 'LHC' || ltTypecode == 'LSC'" class="openNum" :class="[
                  (f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] < getSmallNum + 1) ? 'blueBall' : '',
                  (f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] > getSmallNum) ? 'redBall' : '',
                  (f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 == 0) ? 'redBall' : '',
                  (f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 != 0) ? 'blueBall' : '',
                  (f == 'num') ? 'lhc' + findNumbColor(lotteryNum[index][lotteryNum[index].length - 1]) : ''
                ]">
                  <template v-if="f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] < getSmallNum">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && lotteryNum[index][lotteryNum[index].length - 1] > getSmallNum - 1">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && lotteryNum[index][lotteryNum[index].length - 1] % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ lotteryNum[index][lotteryNum[index].length - 1] }}
                  </template>
                  <div class="animals">
                    {{ findNumbAnimal(lotteryNum[index][lotteryNum[index].length - 1],
                      getAnimalList(item.periodsNumber, ltTypecode)) }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'PK10'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items <= 5) ? 'blueBall' : '', (f == 'dx' && items > 5) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items <= 5">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 5">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == 'PL3'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items < 5">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 4">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == 'SSC'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items < 5">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 4">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == 'ZHISHU'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items <= 4) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items <= 4">
                    跌
                  </template>
                  <template v-else-if="f == 'dx' && items > 4">
                    涨
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
                <div v-if="ltTypecode == 'SSQ'" class="openNum lhcred" v-for="(items, i) in lotteryNum[index]" :key="i"
                  v-show="i + 1 != lotteryNum[index].length && 'true'">
                  <div>
                    {{ items }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'SSQ'" class="openNum noBackground ">
                  +
                </div>
                <div v-if="ltTypecode == 'SSQ'" class="openNum lhcblue">
                  <div>
                    {{ lotteryNum[index][lotteryNum[index].length - 1] }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'DLT'" class="openNum lhcred"
                  v-for="(items, i) in lotteryNum[index].slice(0, 5)" :key="i">
                  <div>
                    {{ items }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'DLT'" class="openNum noBackground ">
                  +
                </div>
                <div v-if="ltTypecode == 'DLT'" class="openNum lhcblue">
                  <div>
                    {{ lotteryNum[index][lotteryNum[index].length - 2] }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'DLT'" class="openNum lhcblue">
                  <div>
                    {{ lotteryNum[index][lotteryNum[index].length - 1] }}
                  </div>
                </div>
                <div v-if="ltTypecode == 'PCDD'" class="openNum" v-for="(items, i) in lotteryNum[index]"
                  :class="[(f == 'dx' && items < 5) ? 'blueBall' : '', (f == 'dx' && items > 4) ? 'redBall' : '', (f == 'ds' && items % 2 == 0) ? 'redBall' : '', (f == 'ds' && items % 2 != 0) ? 'blueBall' : '']"
                  :key="i">
                  <template v-if="f == 'dx' && items < 5">
                    小
                  </template>
                  <template v-else-if="f == 'dx' && items > 4">
                    大
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 == 0">
                    双
                  </template>
                  <template v-else-if="f == 'ds' && items % 2 != 0">
                    单
                  </template>
                  <template v-else>
                    {{ items }}
                  </template>
                </div>
              </div>
              <div :class="[ltTypecode == '3D' && 'threeGrid', ltTypecode == '11X5' && 'threeGrid', ltTypecode == 'K3' && 'threeGrid', ltTypecode == 'LHC' && 'normalGrid LHC_height', ltTypecode == 'PK10' && 'tigerDragonGrid', ltTypecode == 'PL3' && 'threeGrid', ltTypecode == 'SSC' && 'threeGrid', ltTypecode == 'ZHISHU' && 'oneGrid', ltTypecode == 'SSQ' && 'twoGrid', ltTypecode == 'DLT' && 'twoGrid', ltTypecode == 'PCDD' && 'threeGrid', ltTypecode == 'LSC' && 'normalGrid LHC_height']
                ">
                <div v-for="(items, i) in addAll[index]" :key v-if="ltTypecode != 'ZHISHU'">
                  {{ items }}
                </div>
                <div v-if="ltTypecode == 'ZHISHU'">
                  {{ zhishuNiuonXiong[index].join('') }}
                </div>
              </div>
              <div class="grid_column" v-if="ltTypecode == 'PK10'">
                {{ sscDragonTigerpk[index].join('') }}
              </div>
            </div>
          </div>
          <template v-slot:loading>
            <div class="row justify-center q-my-md">
              <q-spinner-dots color="primary" size="40px"></q-spinner-dots>
            </div>
          </template>
        </q-infinite-scroll>
      </div>
    </template>
    <template v-if="historyrecord">
      <div class="empty">
        <div data-v-3ba12b9b="" class="wrap-svg">
          <img src="../../assets/pc_empty_state.svg">
          <div class="empty">暂无记录</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { ApiqueryHisPeriodsPage } from "@/service";
import lhcMixins from '~/mixins/lhc.mixins'
// import { ApiqueryHisPeriodsPage } from "../../api/service";
export default {
  mixins: [lhcMixins],
  data() {
    return {
      lotteryTypecode: '',
      lotterycode: '',
      scrollTargetRef: null,
      status:true,
      list: [],
      page: 1,
      totalPage: 1,
      loading: false,
      historyrecord: false,
      lotteryNum: [], // 表格里面的开奖号码
      firstAddSecondpk: [], // pk10冠亚和
      oneFiveDragonTigerpk: [], // pk10 1-5龙虎
      addAll: [], // k3总和
      sscAddAll: [], // ssc总和
      sscDragonTigerpk: [], // ssc 1-5龙虎
      lhcAddAll: [], // lhc总和
      theredAddAll: [],//3D
      ssqAddAll: [],//ssq总和
      zhishuNiuonXiong: [],//zhishu
    }
  },
  props: {
    ltTypecode: {
      type: [String],
      default: "home"
    },
    f: {
      type: [String],
      default: "num"
    },
    lottery: {
      type: [Object],
      default: null
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.loading = true;
        this.lotteryTypecode = this.$route.query.lotteryTypeCode;
        this.lotterycode = this.$route.query.lotteryCode;
        this.$store.commit(
          "lottery/setlotteryTypeCode",
          this.lotteryTypecode
        );
        // this.$store.commit(
        //   "lottery/setHisLotteryList", []
        // );
        this.$store.commit("lottery/setlotteryCode", this.lotterycode);
        // this.$store.commit(
        //   "lottery/setHisLotteryList", []
        // );
        if (this.$route.query.lotteryCode) {
          this.page = 1;
          this.list = [];
          this.init();
        }
      },
      immediate: true,
      deep: true
    },
    "lottery.status"() {
      console.log("倒计时lottery.status改变");
    },
    lottery: {
      handler(newVal, oldVal) {
        if(newVal && newVal.last) {
          const info = this.list[0]
          if(info && newVal.last.drawingNumber) {
            // 手动赋值最新列表数据
            if(newVal.last.periodsId - 1 == info.periodsId) {
              newVal.last.actualDrawingDate = newVal.last.theoryDrawingDate
              this.list.unshift(newVal.last)
              this.getTableData()
            }
            // 说明中间有未开奖的期数，重新获取列表数据
            if(newVal.last.periodsId - 1 > info.periodsId) {
              this.page = 1;
              this.list = [];
              this.init();
            }
          }
          
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    // 获取LHC和LSC开奖号码值为小的最大数
    getSmallNum() {
      if (this.ltTypecode == 'LSC') return 31
      return 25
    }
  },
  mounted() {
    // this.init()
    console.log(this.ltTypecode)
  },
  methods: {
    onLoad(index, done) {
      if (this.page == this.totalPage || this.page > this.totalPage) {
        this.historyrecord = true;
        done()
        stop()
        return
      } else {
        this.page = this.page + 1;
        this.init();
        setTimeout(() => {
          done()
        }, 1000)
      }
    },
    getAnimalList(periodsNumber, lotteryTypeCode = 'lhc') {
      return this.getCurrYearAnimal(periodsNumber.slice(0, 4), lotteryTypeCode);
    },
    async init() {
      this.status = false
      var obj = {
        limit: 20,
        page: this.page,
        lotteryCode: this.$route.query.lotteryCode || this.lotteryCode
      }
      const res = await ApiqueryHisPeriodsPage(obj);
      if (res.code == '12200') {
        if (res.data.list.length == 0) {
          // 无记录
          this.historyrecord = true;
        } else {
          this.historyrecord = false;
        }
        const { list } = this
        // 总开奖数据
        const array = this.page == 1 ? res.data.list : list.concat(res.data.list)
        // 数组去重
        this.list = array.filter((item, index, self) =>
          index === self.findIndex(t => t.periodsId === item.periodsId)
        );
        this.page = res.data.currPage;
        this.totalPage = res.data.totalPage
        this.getTableData()
        setTimeout(()=>{
          this.status = true
        },500)
      } else {
        this.status = true
      }
    },
    getTableData() {
      // 表格里面的号码
      let lotteryTypecode = this.lotteryTypecode || this.$route.query.lotteryCode
      let numList = this.list.map(item => item.drawingNumber).map(item => item.split(","));
      this.lotteryNum = numList;
      let tool1 = []; // 冠亚和(3个数据)
      let tool2 = []; // 龙虎(5个数)
      let tool3 = [];
      for (let item of numList) {
        if (lotteryTypecode == "PK10") {
          let add = [];
          let num = item[0] * 1 + item[1] * 1;
          let bigSmall = num > 11 ? "大" : "小";
          let oddEven = (num % 2 == 0) ? "双" : "单";
          add.push(num, bigSmall, oddEven);
          tool1.push(add);

          let battle = [];
          if (item[0] > item[9]) { battle.push("龙") } else { battle.push("虎") }
          if (item[1] > item[8]) { battle.push("龙") } else { battle.push("虎") }
          if (item[2] > item[7]) { battle.push("龙") } else { battle.push("虎") }
          if (item[3] > item[6]) { battle.push("龙") } else { battle.push("虎") }
          if (item[4] > item[5]) { battle.push("龙") } else { battle.push("虎") }
          tool2.push(battle)
        } else if (lotteryTypecode == "SSQ" || lotteryTypecode == "DLT") {
          let add = [];
          // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
          let num = item.reduce((a, b) => { return a * 1 + b * 1 })
          let oddEven = (num % 2 == 0) ? "双" : "单";
          add.push(num, oddEven);
          tool1.push(add);
        } else if (lotteryTypecode == "K3" || lotteryTypecode == "LHC" || lotteryTypecode == "LSC") {
          let add = [];
          // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
          let num = item.reduce((a, b) => { return a * 1 + b * 1 })
          let bigSmall = num > 10 ? "大" : "小";
          let oddEven = (num % 2 == 0) ? "双" : "单";
          if (lotteryTypecode == "LHC" || lotteryTypecode == "LSC") {
            let sebo = [
              {
                code: "红",
                list: [
                  "01",
                  "02",
                  "07",
                  "08",
                  "12",
                  "13",
                  "18",
                  "19",
                  "23",
                  "24",
                  "29",
                  "30",
                  "34",
                  "35",
                  "40",
                  "45",
                  "46",
                  '51',
                  '56',
                  '57'
                ]
              },
              {
                code: "蓝",
                list: [
                  "03",
                  "04",
                  "09",
                  "10",
                  "14",
                  "15",
                  "20",
                  "25",
                  "26",
                  "31",
                  "36",
                  "37",
                  "41",
                  "42",
                  "47",
                  "48",
                  '52',
                  '53',
                  '58',
                  '59'
                ]
              },
              {
                code: "绿",
                list: [
                  "05",
                  "06",
                  "11",
                  "16",
                  "17",
                  "21",
                  "22",
                  "27",
                  "28",
                  "32",
                  "33",
                  "38",
                  "39",
                  "43",
                  "44",
                  "49",
                  '50',
                  '54',
                  '55',
                  '60'
                ]
              }
            ]
            let color = sebo.find(e => e.list.includes(item[item.length - 1]));
            add.push(num, bigSmall, oddEven, color.code);
          } else {
            add.push(num, bigSmall, oddEven);
          }
          tool1.push(add);
        } else if (lotteryTypecode == "PCDD") {
          let add = [];
          let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
          let bigSmall = num > 13 ? "大" : "小";
          let oddEven = (num % 2 == 0) ? "双" : "单";
          add.push(num, bigSmall, oddEven);
          tool1.push(add);
        } else if (lotteryTypecode == "SSC" || lotteryTypecode == "11X5") {
          let add = [];
          // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
          let num = item.reduce((a, b) => { return a * 1 + b * 1 })
          let bigSmall = num > 22 ? "大" : "小"; // 仅ssc
          let oddEven = (num % 2 == 0) ? "双" : "单";
          add.push(num, bigSmall, oddEven);
          tool1.push(add);

          let battle = [];
          if (item[0] > item[4]) { battle.push("龙") } else if (item[0] == item[4]) { battle.push("和") } else { battle.push("虎") }
          tool2.push(battle)
        } else if (lotteryTypecode == "3D" || lotteryTypecode == "PL3") {
          let add = [];
          let num = item.reduce((a, b) => { return a * 1 + b * 1 })
          let bigSmall = num > 13 ? "大" : "小";
          let oddEven = (num % 2 == 0) ? "双" : "单";
          add.push(num, bigSmall, oddEven);
          tool1.push(add);
        } else if (lotteryTypecode == "ZHISHU") {
          let battle = [];
          if (item[0] > item[1]) { battle.push("牛") } else { battle.push("熊") }
          tool3.push(battle)
        }
      }
      // pk10
      this.firstAddSecondpk = tool1
      this.oneFiveDragonTigerpk = tool2
      this.addAll = tool1
      this.theredAddAll = tool1
      // ssc || 11x5
      this.sscAddAll = tool1
      this.sscDragonTigerpk = tool2
      // lhc
      this.lhcAddAll = tool1
      
      //ssq
      this.ssqAddAll = tool1
      // zhishu
      this.zhishuNiuonXiong = tool3
    }
  }
}
</script>
<style lang="less">
.grid_body {
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;

  .wrap-loading {
    margin-top: 150px;

    .notContent {
      text-align: center;
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    font-size: 14px;

    .grid_container {
      font-size: 14px
    }

    .wrap-svg {
      margin-top: 100px
    }

    .empty {
      margin-bottom: 67px
    }
  }

  .q-list {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .LHC_column {
    height: 70px !important;
  }

  .grid_column {
    border-bottom: 1px solid #d3d3d3;
    border-right: 1px solid #d3d3d3;
    place-content: center;
    display: grid;
    grid-auto-flow: column;
    height: 50px;

    .openNum {
      display: grid;
      place-items: center;
      width: 36px;
      height: 36px;
      background: #e5e2f3;
      border-radius: 100%;
      margin-right: 12px;
      position: relative;

      .animals {
        position: absolute;
        bottom: -23px;
      }
    }

    .noBackground {
      background: hsla(0, 0%, 100%, 0);
    }

    .lhcred {
      background: #f7dfdf;
    }

    .lhcblue {
      background: #deeaf0;
    }

    .lhcgreen {
      background: #d3e8d2;
    }

    .blueBall {
      background: #deeaf0;
    }

    .redBall {
      background: #f7dfdf;
    }

    .K3No {
      background: url(../../assets/open_num.png) no-repeat center 0;
      background-size: cover;
      border-radius: 0;
      margin-top: 3px
    }

    .K3No1 {
      background-position: 50% 1%
    }

    .K3No2 {
      background-position: 50% 17.79%
    }

    .K3No3 {
      background-position: 50% 34.232%
    }

    .K3No4 {
      background-position: 50% 50.974%
    }

    .K3No5 {
      background-position: 50% 67.616%
    }

    .K3No6 {
      background-position: 50% 84.4%
    }
  }

  .threeGrid {
    display: grid;
    grid-auto-flow: column;
    border-right: 1px solid #d3d3d3;
  }

  .normalGrid {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(4, 54px);
    border-right: 1px solid #d3d3d3;
  }

  .normalGrid>div {
    height: 50px;
    align-items: center;
    justify-items: center;
    display: grid;
    border-bottom: 1px solid #d3d3d3;
  }

  .normalGrid>div:first-child {
    border-right: 1px solid #d3d3d3;
    height: 50px;
  }

  .normalGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .normalGrid>div:nth-child(3) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .oneGrid {
    border-bottom: 1px solid #d3d3d3;
    line-height: 50px;
    text-align: center;
  }

  .oneGrid>div {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .twoGrid {
    border-bottom: 1px solid #d3d3d3;
    display: flex;
    grid-auto-flow: column;
  }

  .twoGrid>div:first-child,
  .twoGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    flex: 1;
    height: 50px;
    text-align: center;
    line-height: 50px;
  }

  .oneGrid>div {
    border-right: 1px solid #d3d3d3;
    align-items: center;
    justify-items: center;
    display: grid;
  }

  .threeGrid>div {
    align-items: center;
    justify-items: center;
    display: grid;
    width: 72px;
    border-bottom: 1px solid #d3d3d3;
  }

  .threeGrid>div:first-child {
    border-right: 1px solid #d3d3d3;
    height: 50px;
  }

  .threeGrid>div:nth-child(2) {
    border-right: 1px solid #d3d3d3;
    height: 50px
  }

  .tigerDragonGrid {
    display: grid;
    grid-auto-flow: column
  }

  .tigerDragonGrid>div {
    align-items: center;
    justify-items: center;
    display: grid;
    width: 48px;
    border-bottom: 1px solid #d3d3d3;
  }

  .tigerDragonGrid>div:first-child,
  .tigerDragonGrid>div:nth-child(2),
  .tigerDragonGrid>div:nth-child(3) {
    height: 50px;
    border-right: 1px solid #d3d3d3;
  }

  .LHC_height div:first-child,
  .LHC_height div:nth-child(2),
  .LHC_height div:nth-child(3),
  .LHC_height div:nth-child(4),
  .LHC_height {
    height: 70px !important
  }

  .LHC_column .openNum {
    top: -9px;
  }

  .record-data {
    display: grid;
    grid-template-columns: 180px 140px 2fr 219px;
    border-left: 1px solid #d3d3d3;
  }

  .fiveColumn {
    grid-template-columns: 180px 140px 2fr 147px 133px
  }

  .record-data:hover {
    background: #fff8ec
  }
}
</style>